export function buildShirtBlocks(generated = {}) {
  return [
    { key: 'front', label: 'Front', path: generated.frontPath || '', enabled: Boolean(generated.frontPath) },
    { key: 'back', label: 'Back', path: generated.backPath || '', enabled: Boolean(generated.backPath) },
    { key: 'yoke', label: 'Yoke', path: generated.yokePath || '', enabled: Boolean(generated.yokePath) },
    { key: 'sleeve', label: 'Sleeve', path: generated.sleevePath || '', enabled: Boolean(generated.sleevePath) },
    { key: 'collar', label: 'Collar', path: generated.collarBandLayoutPath || generated.collarBandPath || '', enabled: Boolean(generated.collarBandLayoutPath || generated.collarBandPath) },
    { key: 'collarLeaf', label: 'Collar Leaf', path: generated.collarLeafLayoutPath || '', enabled: Boolean(generated.collarLeafLayoutPath) },
  ];
}

export function getShirtBlockByKey(generated = {}, key) {
  return buildShirtBlocks(generated).find((block) => block.key === key) || null;
}
